import router from '../router/index'
import store from '../store'
import ROLE from '../enums/roles'
// import userIds from '../enums/userId'

/**
 * Helper function to check if permissions are loaded in store
 */
function arePermissionsLoaded() {
  return !!(store.state.globalComponents?.permissions?.permissionGroups)
}

/**
 * Helper function to check if user has dashboard-tab view permission
 * Returns null if permissions aren't loaded yet, true/false otherwise
 */
function hasDashboardPermission() {
  if (!arePermissionsLoaded()) {
    return null // Permissions not loaded yet
  }
  const dashboardPermissions = (store.state.globalComponents.permissions.permissionGroups['dashboard-tab'] ?? [])
    .filter((perm) => perm.name.startsWith('dashboard-tab.'))
    .map((perm) => perm.name.split('.')[1])
  return dashboardPermissions.includes('view')
}

/**
 * Helper function to check if user has household view permission (member.view or opportunity.view)
 * Returns null if permissions aren't loaded yet, true/false otherwise
 */
function hasHouseholdPermission() {
  if (!arePermissionsLoaded()) {
    return null // Permissions not loaded yet
  }
  const memberPermissions = (store.state.globalComponents.permissions.permissionGroups.member ?? [])
    .filter((perm) => perm.name.startsWith('member.'))
    .map((perm) => perm.name.split('.')[1])
  const opportunityPermissions = (store.state.globalComponents.permissions.permissionGroups.opportunity ?? [])
    .filter((perm) => perm.name.startsWith('opportunity.'))
    .map((perm) => perm.name.split('.')[1])
  return memberPermissions.includes('view') || opportunityPermissions.includes('view')
}

export function useRoutRedirect() {
  const routRedirect = async ({ role, userId }) => {
    // const memberId = store.state.globalComponents?.userId
    if (role === ROLE.ADVISOR) {
      console.log('Checking permissions for advisor redirect...', store.state.globalComponents?.permissions?.permissionGroups)
      
      const hasDashboard = hasDashboardPermission()
      const hasHousehold = hasHouseholdPermission()
      
      // If permissions aren't loaded yet (returns null), default to revenue-dashboard
      // The route guard will handle the actual permission check when user arrives there
      if (hasDashboard === null || hasHousehold === null) {
        console.log('Permissions not loaded yet, defaulting to revenue-dashboard')
        router.push({ name: 'advisor/revenue-dashboard' })
        return
      }
      
      // Permissions are loaded, check them
      if (hasDashboard) {
        router.push({ name: 'advisor/revenue-dashboard' })
      }
      // If no dashboard permission, check household permission
      else if (hasHousehold) {
        router.push({ name: 'advisor/all' })
      }
      // Fallback to rebalance form if no permissions
      else {
        router.push({ name: 'rebalance-form' })
      }
    }
    if (role === ROLE.LEAD) router.push({ name: 'lead/dashboard' })
    if (role === ROLE.ADMIN) router.push({ name: 'admin/revenue-dashboard' })
    if (role === ROLE.CEO) router.push({ name: 'ceo/revenue-dashboard' })
    if (role === ROLE.ASSISTANT) router.push({ name: 'advisor/revenue-dashboard' })
    if (role === ROLE.SUPPORT) router.push({ name: 'support/revenue-dashboard' })
    if (role === ROLE.CLIENT) router.push({ name: `client/member-details`, params: { id: userId } })
  }
  return { routRedirect }
}
